/**
 * 渠道模块接口
 */

import serviceApi from './serviceApi';

export default {
  ...serviceApi,
};
